import { useContext } from 'react';

import { TableCell, TableRow } from '@repo/videa-components/src/ui/table';
import classNames from 'classnames';

import { getToothStateLabel } from './helpers';
import { PerioChartModeContext, type PerioChartTooth } from './types';

interface Props {
  label: string;
  teeth: PerioChartTooth[];
}

export const ToothStatusRow = ({ label, teeth }: Props) => {
  const mode = useContext(PerioChartModeContext);

  return (
    <TableRow className="vai-border-none">
      <TableCell
        className={classNames(
          'vai-font-inter vai-text-[12px] !vai-py-[2px] !vai-px-2 vai-font-medium',
          {
            'vai-text-zinc-300': mode === 'dark',
            'vai-text-zinc-950': mode === 'light',
          },
        )}
      >
        {label}
      </TableCell>

      {teeth.map((tooth) => (
        <TableCell
          className={classNames(
            'vai-font-inter vai-text-[12px] !vai-py-[2px] !vai-px-2 vai-font-bold',
            {
              'vai-text-sapphire-500': mode === 'dark',
              'vai-text-sapphire-600': mode === 'light',
            },
          )}
          key={tooth.toothNumber}
        >
          <p className="vai-text-center">
            {getToothStateLabel(tooth.toothState)}
          </p>
        </TableCell>
      ))}
    </TableRow>
  );
};
